module.exports = __webpack_public_path__ + "static/img/icon_wind_bg@2x.a09bb9ae.png";